// extracted by mini-css-extract-plugin
export default {"CoachList":"CoachList_CoachList__M6LUG","ListTitle":"CoachList_ListTitle__YczC3","List":"CoachList_List__u6SxM"};